import {
    AppBar,
    Box,
    Button,
    Container,
    makeStyles,
    Menu,
    MenuItem,
    Toolbar,
    withStyles
} from "@material-ui/core";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import StorageIcon from '@material-ui/icons/Storage';
import PersonIcon from '@material-ui/icons/Person';
import React from "react";
import { myAxios } from "../utils/request";
import { useAppState } from "../context/zustand";
import ButtonSystemsLogo from '../assets/ButtonSystems_logo_square.png';
import { BA_STYLE_TOKENS } from "../utils/utils";

const MenuButton = withStyles(() => ({
    root: {
        '&:hover': {
            backgroundColor: '#163174',
            boxShadow: 'none',
        },
        backgroundColor: BA_STYLE_TOKENS.brand,
        color: '#ffffff',
        boxShadow: 'none',
        marginLeft: 12,
        minHeight: 36,
        textTransform: 'none',
    },
}))(Button);

const useStyles = makeStyles((theme) => ({
    header: {
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #e2e7ef',
        color: '#101828',
        boxShadow: 'none',
    },
    toolbar: {
        display: "flex",
        justifyContent: "space-between",
        minHeight: 64,
        gap: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            alignItems: 'flex-start',
            flexDirection: 'column',
            paddingBottom: theme.spacing(1),
            paddingTop: theme.spacing(1),
        },
    },
    brand: {
        alignItems: 'center',
        color: '#101828',
        display: 'flex',
        fontSize: '1.05rem',
        fontWeight: 700,
        gap: theme.spacing(1.25),
        minWidth: 0,
        whiteSpace: 'nowrap',
    },
    brandMark: {
        borderRadius: '0.375rem',
        height: '2.25rem',
        objectFit: 'contain',
        width: '2.25rem',
    },
    actions: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        rowGap: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'flex-start',
        },
    },
}));

export default function Header() {
    const classes = useStyles();
    const isAdmin = useAppState(s => s.isAdmin);
    const username = useAppState(s => s.username);
    const logout = useAppState(s => s.logout);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const headersData = [
        {
            label: "Admin panel",
            onClick: () => {
                window.open(`${myAxios.defaults.baseURL}/db-manager`, '_blank', 'noopener,noreferrer');
            },
            icon: <StorageIcon />
        },
    ].filter(() => isAdmin);

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <header>
            <AppBar className={classes.header}>
                <Toolbar className={classes.toolbar} component={Container}>
                    <Box className={classes.brand}>
                        <img className={classes.brandMark} src={ButtonSystemsLogo} alt="" />
                        <span>Podcasts</span>
                    </Box>
                    <Box className={classes.actions}>
                        {headersData.map(({ label, icon, onClick }) => (
                            <MenuButton
                                variant="contained"
                                key={`MenuButton${label}`}
                                startIcon={icon}
                                onClick={onClick}
                            >
                                {label}
                            </MenuButton>
                        ))}
                        <MenuButton
                            variant="contained"
                            key="MenuButtonUser"
                            startIcon={<PersonIcon />}
                            onClick={(event) => setAnchorEl(event.currentTarget)}
                        >
                            {username}
                        </MenuButton>
                        <Menu
                            id="user-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                        >
                            <MenuItem onClick={() => { logout(); }}>
                                <ExitToAppIcon fontSize="small" />
                                <Box marginLeft={1}>Logout</Box>
                            </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </AppBar>
        </header>
    );
}
